var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useCallback, useEffect, useMemo, useState, } from 'react';
import { useOpts } from '../../context';
import { formatLinkApiResponse } from '../../utils/link-api';
import sleep from '../../utils/sleep';
import getFetch from '../utils/isofetch';
import { getLinkApiHeaders, getLinkApiMethod, getLinkApiUrl, } from '../utils/link-api-requests';
import { JOB_STEP_HISTORY } from './initialValues';
export var jobStepHistoryContext = createContext(JOB_STEP_HISTORY);
var getFormattedResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, response.json()];
            case 1:
                json = _a.sent();
                return [2 /*return*/, formatLinkApiResponse(json)];
        }
    });
}); };
var LinkApiHistoryProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), jobStepHistory = _b[0], setJobStepHistory = _b[1];
    var _c = useState(false), isRevertingLastJobStep = _c[0], setIsRevertingLastJobStep = _c[1];
    var _d = useState(), setLinkApiResponse = _d[0], setSetLinkApiResponse = _d[1];
    var opts = useOpts();
    var loadedPlatform = opts.loadedPlatform;
    useEffect(function () {
        if (!loadedPlatform)
            setJobStepHistory([]);
    }, [loadedPlatform]);
    var addJobStepHistory = useMemo(function () {
        return function (url, params, newSetLinkApiResponse) {
            // Allow pushing onto request history for first step because we use that length to determine if
            // we are on the default login step or not
            if (jobStepHistory.length >= 1)
                return;
            // Only push history for initialize and next (if you allow step some bullshit happens)
            if (url.includes('/initialize') || url.includes('/next')) {
                var newHistory = __spreadArray(__spreadArray([], jobStepHistory, true), [[url, params]], false);
                setJobStepHistory(newHistory);
            }
            // Why use a factory? https://stackoverflow.com/questions/55621212/is-it-possible-to-react-usestate-in-react
            setSetLinkApiResponse(function () { return newSetLinkApiResponse; });
        };
    }, [jobStepHistory]);
    var revertLastJobStep = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var formatted, i, _a, url, request, response, json, responseFromStep;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsRevertingLastJobStep(true);
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < jobStepHistory.length - 1)) return [3 /*break*/, 9];
                    _a = jobStepHistory[i], url = _a[0], request = _a[1];
                    return [4 /*yield*/, getFetch()(url, request)];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _b.sent();
                    formatted = formatLinkApiResponse(json);
                    _b.label = 4;
                case 4:
                    if (!(formatted.responseType === 'processing')) return [3 /*break*/, 8];
                    return [4 /*yield*/, getFetch()(getLinkApiUrl('step_result'), {
                            method: getLinkApiMethod('step_result'),
                            headers: getLinkApiHeaders(opts),
                        })];
                case 5:
                    responseFromStep = _b.sent();
                    return [4 /*yield*/, getFormattedResponse(responseFromStep)];
                case 6:
                    formatted = _b.sent();
                    return [4 /*yield*/, sleep(1)];
                case 7:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 8:
                    i++;
                    return [3 /*break*/, 1];
                case 9:
                    setLinkApiResponse(formatted);
                    setJobStepHistory(jobStepHistory.slice(0, jobStepHistory.length - 1));
                    setIsRevertingLastJobStep(false);
                    return [2 /*return*/];
            }
        });
    }); }, [jobStepHistory, opts, setLinkApiResponse]);
    var value = useMemo(function () { return ({
        jobStepHistory: jobStepHistory,
        addJobStepHistory: addJobStepHistory,
        isRevertingLastJobStep: isRevertingLastJobStep,
        revertLastJobStep: revertLastJobStep,
    }); }, [
        addJobStepHistory,
        isRevertingLastJobStep,
        jobStepHistory,
        revertLastJobStep,
    ]);
    return (React.createElement(jobStepHistoryContext.Provider, { value: value }, children));
};
export default LinkApiHistoryProvider;
